import React from "react";
import styles from "./versatile.module.scss";
import Image from "next/image";
function Versatile(props: any) {
  return (
    <div className={styles["versatile-wrapper"]}>
      <div className={styles["versatile-wrapper-content"]}>
        <h3>{props.title}</h3>
        <h2>{props.subTitle}</h2>
        <p>{props.text}</p>
      </div>
      <div className={styles["versatile-wrapper-image"]}>
        <Image
          src={props.image}
          alt=""
          height={200}
          width={400}
          className={styles["versatile-image"]}
        />
      </div>
    </div>
  );
}

export default Versatile;
